import styled from 'styled-components';
import { colors } from '../../styles/colors';

export const StyledTimePicker = styled.div`
  .m-dropdown-field {
    border: 1px solid ${colors.grey2};
    width: 124px;
    height: 32px;
    padding: 5px;
    font-size: 14px;
  }
  .error {
    border: 1px solid var(--t-form-error-color) !important;
  }

  .custom-select-wrapper {
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      padding-right: 30px;
      position: relative;
      background: none;
      font-family: inherit;
      width: 107px !important;
      height: 32px !important;
      font-weight: 400 !important;
      color: var(--t-brand-fg-color) !important;
    }
  }

  .custom-select-wrapper {
    position: relative;
    display: inline-block;
  }

  .custom-select-wrapper::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    top: 43% !important;
    right: 10% !important;
    border-left: 2px solid var(--t-brand-fg-color);
    border-bottom: 2px solid var(--t-brand-fg-color);
    transform: rotate(-45deg) translateY(-50%);
    pointer-events: none;
    transition: transform 0.3s;
  }
`;
